<app-buy-sell-menu>
    <app-data-grid-comp
        *ngIf="hasFeatureAccess"
        category="Buy-Sell-Plans"
        [tableId]="tableId"
        [gridId]="gridId"
        [columns]="columns"
        [filterCategories]="filterCategories"
        [gridDataResult]="gridDataResult"
        [pageSize]="pageSize"
        [skip]="skip"
        [clearSelectedItems]="clearSelectedItems"
        [rowSelectionSettings]="{
            canSelectRows: true,
            selectableMode: 'multiple',
            selectRowBy: 'id'
        }"
        clickableRows="true"
        [isLoading]="isLoading"
        searchable="true"
        showRefreshButton="true"
        [rowActionButtons]="gridActionButtons"
        (emitRefreshEvent)="getBuySellPlans()"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        (rowActionEvent)="copy($event)"
        (emitOpenDialogEvent)="editOrCreateBuySellPlan($event)"
        (emitGridStateChangeEvent)="gridStateChange($event)"
        (emitDeleteEvent)="openConfirmDeleteDialog($event)"
    ></app-data-grid-comp>

    <no-feature-access *ngIf="!hasFeatureAccess"></no-feature-access>
</app-buy-sell-menu>
